(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3440],{

/***/ 9037:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[hid]/about",
      function () {
        return __webpack_require__(6434);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ HotelAbout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);
/* harmony import */ var interweave__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9996);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);
/* harmony import */ var _containers_Helmet__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9536);
/* harmony import */ var _layout_FooterHotel__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8078);
/* harmony import */ var _layout_HeaderV3__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4850);
/* harmony import */ var _layout_Section__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1914);









var __N_SSG = true;
function HotelAbout(param) {
    var header = param.header, hotelBrands = param.hotelBrands, hero = param.hero, about_id = param.about_id, about_en = param.about_en, home_subheadline = param.home_subheadline;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().locale;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(0), headerHeight1 = ref[0], setHeaderHeight = ref[1];
    var aboutContent = locale == "id" ? about_id !== null && about_id !== void 0 ? about_id : home_subheadline : about_en !== null && about_en !== void 0 ? about_en : home_subheadline;
    var ref1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_Helmet__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                title: locale == "id" ? "Tentang Kami | ".concat(header.name) : "About Us | ".concat(header.name),
                description: aboutContent
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_HeaderV3__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                headerItem: header,
                isHomepage: false,
                getHeight: function(headerHeight) {
                    return setHeaderHeight(headerHeight);
                },
                hotelBrands: hotelBrands
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                h: headerHeight1
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layout_Section__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6q, {
                        as: "h1",
                        mb: 6,
                        textAlign: "center",
                        color: header.color_primary,
                        children: locale === "id" ? "Tentang Kami" : "About Us"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(interweave__WEBPACK_IMPORTED_MODULE_2__/* .Markup */ .Lu, {
                        className: "white-space-enter",
                        content: (ref1 = aboutContent === null || aboutContent === void 0 ? void 0 : aboutContent.replace(/\\n/g, "<br>")) !== null && ref1 !== void 0 ? ref1 : ""
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_FooterHotel__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                instagram: header.instagram,
                facebook: header.facebook,
                locationLink: header.location_url,
                location: header.location_long,
                email: header.email,
                phone: header.phone,
                bg: header.color_primary,
                color: header.color_secondary,
                logo: header.logo_light,
                hotelSlug: header.slug
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,5525,9996,4939,8078,9774,2888,179], function() { return __webpack_exec__(9037); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);